module.exports = __webpack_public_path__ + "static/media/ooloi_logo_white.42d4a68a.svg";